/* Campo quick-add: click a size on a collection card to add it to the cart.
   Dawn's card link overlay paints above the strip, so clicks are intercepted
   in the capture phase and hit-tested by coordinates instead. */
(function () {
  function addVariant(button) {
    var variantId = button.dataset.variantId;
    if (!variantId || button.classList.contains('loading')) return;
    button.classList.add('loading');

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          console.error('Campo quick-add error:', response.description || response.message);
          return;
        }
        if (cart) {
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: variantId,
              cartData: response,
            });
          }
          cart.renderContents(response);
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch(function (e) {
        console.error(e);
      })
      .finally(function () {
        button.classList.remove('loading');
      });
  }

  function within(rect, x, y) {
    return rect.width > 0 && x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
  }

  function stripButtonAt(x, y) {
    var strips = document.querySelectorAll('.campo-size-strip, .campo-size-row');
    for (var i = 0; i < strips.length; i++) {
      var strip = strips[i];
      var scs = getComputedStyle(strip);
      if (scs.display === 'none' || scs.opacity === '0') continue;
      if (!within(strip.getBoundingClientRect(), x, y)) continue;
      var buttons = strip.querySelectorAll('button[data-variant-id]');
      for (var j = 0; j < buttons.length; j++) {
        if (within(buttons[j].getBoundingClientRect(), x, y)) return buttons[j];
      }
      return strip; // clicked the strip ground: swallow so the card link doesn't fire
    }
    return null;
  }

  document.addEventListener(
    'click',
    function (evt) {
      var hit = stripButtonAt(evt.clientX, evt.clientY);
      if (!hit) return;
      evt.preventDefault();
      evt.stopPropagation();
      if (hit.tagName === 'BUTTON') addVariant(hit);
    },
    true
  );

  // hover feedback: underline the size under the pointer
  document.addEventListener(
    'mousemove',
    function (evt) {
      var hovered = stripButtonAt(evt.clientX, evt.clientY);
      document.querySelectorAll('.campo-size-strip__size--hovered').forEach(function (el) {
        if (el !== hovered) el.classList.remove('campo-size-strip__size--hovered');
      });
      if (hovered && hovered.tagName === 'BUTTON') hovered.classList.add('campo-size-strip__size--hovered');
    },
    true
  );
})();


/* colorway bar on cards: hover a dot swaps the card image in place,
   click goes to that colorway's page. The card's stretched link overlay
   sits above the bar, so we hit-test coordinates instead of relying on
   event targets (same approach as the size quick-add row). */
(function () {
  function dotAt(x, y) {
    var dots = document.querySelectorAll('.campo-color-bar__dot');
    for (var i = 0; i < dots.length; i++) {
      var d = dots[i];
      var bar = d.closest('.campo-color-bar');
      if (!bar || getComputedStyle(bar).opacity === '0') continue;
      var r = d.getBoundingClientRect();
      if (r.width && x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) return d;
    }
    return null;
  }

  function swap(dot) {
    var card = dot.closest('.card-wrapper');
    if (!card) return;
    var url = dot.getAttribute('data-swap-img');
    if (url) {
      card.querySelectorAll('.card__media .media img').forEach(function (img) {
        img.removeAttribute('srcset');
        img.src = url;
      });
    }
    var name = card.querySelector('[data-colorbar-name]');
    if (name) name.textContent = dot.getAttribute('data-swap-name') || '';
    var href = dot.getAttribute('data-swap-href');
    if (href) {
      card.querySelectorAll('.card__heading a, a.full-unstyled-link').forEach(function (a) {
        a.href = href;
      });
    }
    card.querySelectorAll('.campo-color-bar__dot').forEach(function (d) {
      d.classList.toggle('campo-color-bar__dot--active', d === dot);
    });
  }

  var lastDot = null;
  document.addEventListener('mousemove', function (e) {
    var dot = dotAt(e.clientX, e.clientY);
    document.body.classList.toggle('campo-dot-hover', !!dot);
    if (dot && dot !== lastDot) swap(dot);
    lastDot = dot;
  }, { passive: true });

  document.addEventListener('click', function (e) {
    var dot = dotAt(e.clientX, e.clientY);
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    if (dot.classList.contains('campo-color-bar__dot--active')) {
      var href = dot.getAttribute('data-swap-href');
      if (href) window.location.href = href;
    } else {
      swap(dot);
    }
  }, true);
})();
